export * from '../../common/users/userConstants';

export const TRACK_USERS = 'TRACK_USERS';
export const USERS_LOAD = 'USERS_LOAD';
export const USER_ACTIVITY_LOAD = 'USER_ACTIVITY_LOAD';
export const USER_ACTIVITY_CLEAR = 'USER_ACTIVITY_CLEAR';
export const USER_ACTIVITY_ERROR = 'USER_ACTIVITY_ERROR';
